import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DefineService } from 'src/app/appServices/DefineService/define-service';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-common-facility-grid',
  templateUrl: './common-facility-grid.component.html',
  styleUrls: ['./common-facility-grid.component.scss']
})
export class CommonFacilityGridComponent implements OnInit {
  @ViewChild('dt') dt: Table | undefined;
  rows:number = 15;
  @Input() totalRecords:number = 0;
  cols: any;
  standerdProcessBool:boolean = false;
  FacilityName: string = '';
  implementationName!:string;
  implementationBool:boolean = false;
  @Input() commonFacilityData: any = [];
  @Input() facilitiesData: EventEmitter<any> = new EventEmitter<any>();
  @Output() lazyLoadEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() standerprocessIconPreParam = new EventEmitter<{facilityId:string, facilityName:string}>();
  @Output() standerprocessIconPostParam = new EventEmitter<{facilityId:string, facilityName:string}>();
  @Output() onContextMenuEvent = new EventEmitter<{$event:MouseEvent,facilityId:string, facilityName:string, type:string}>();
  @Output() getFacilityDetailByFacilityIdEvent = new EventEmitter<any>();
  facilityBool: boolean = false;
  @Input() roleForFacility: boolean = false;
  @Input() isAccessReadWrite: boolean = false;
  @Input() isAccessRead: boolean = false;

  constructor (private defineService: DefineService) { }

  ngOnInit(): void {
    console.log(this.isAccessReadWrite)
    let urlPath = window.location.href;
    if(urlPath.includes('StandardProcess')){
      this.standerdProcessBool = true;
      this.facilityBool = false;
    }else{
      this.facilityBool = true;
      this.standerdProcessBool = false;
    }
  };

  ngAfterViewInit() {
    if (this.dt) {
        this.defineService.setDtTable(this.dt);
    }
  }
  showStanderdProcessPre(facilityId:string, facilityName:string){
   this.standerprocessIconPreParam.emit({facilityId, facilityName});
  };
  showStanderdProcessPost(facilityId:string, facilityName:string){
   this.standerprocessIconPostParam.emit({facilityId, facilityName});
  };
  onContextMenu($event:MouseEvent, facilityId: string, facilityName: string, type:string){
    this.onContextMenuEvent.emit({$event,facilityId, facilityName, type})
  };
  getFacilityDetailByFacilityId(facilityId: string, facilityName: string) {
    this.getFacilityDetailByFacilityIdEvent.emit({ facilityId, facilityName });
  };
  onContextMenuPreventDefault(event: MouseEvent) {
    event.preventDefault();
  };
  lazyLoadSchedules($event:any){
    this.lazyLoadEvent.emit($event)
  }
}





